import { render, staticRenderFns } from "./orderiklanrevisionfrm.vue?vue&type=template&id=6fb9feac&scoped=true"
import script from "./orderiklanrevisionfrm.vue?vue&type=script&lang=js"
export * from "./orderiklanrevisionfrm.vue?vue&type=script&lang=js"
import style0 from "./orderiklanrevisionfrm.vue?vue&type=style&index=0&id=6fb9feac&prod&scoped=true&lang=css"
import style1 from "./orderiklanrevisionfrm.vue?vue&type=style&index=1&id=6fb9feac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb9feac",
  null
  
)

export default component.exports